import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getFormatValues } from '../../../../lib/utils';

import styles from '../../../../../styles/guest/sections/content/publications.module.scss';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Publications = ({ active, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.active]: active,
            },
        ])}
    >
        <div className={styles.top}>
            <h2>
                <FormattedMessage
                    defaultMessage="If you can imagine it, you can post it."
                    description="Guest content - publications title"
                    values={getFormatValues()}
                />
            </h2>
        </div>
        <div className={styles.middle}>
            <p>
                <FormattedMessage
                    defaultMessage="Whether via a QR code, by email, or even by SMS, several export and sharing options are available to quickly deploy your stories to your subscribers, your team, or your customers!"
                    description="Guest content - publications description 3"
                    values={getFormatValues()}
                />
            </p>
        </div>
        <div className={styles.bottom}>
            <p>
                <FormattedMessage
                    defaultMessage="Micromags can easily be integrated into your digital space and distributed on your brand’s domain, with or without a login identifier."
                    description="Guest content - publications description 2"
                    values={getFormatValues()}
                />
            </p>
            <ul className={styles.services}>
                <li className={classNames([styles.service, styles.instagram])}>
                    <FormattedMessage
                        defaultMessage="Instagram"
                        description="Instagram"
                        values={getFormatValues()}
                    />
                </li>
                <li className={classNames([styles.service, styles.appleNews])}>
                    <FormattedMessage
                        defaultMessage="Apple News"
                        description="Apple News"
                        values={getFormatValues()}
                    />
                </li>
                <li className={classNames([styles.service, styles.instantArticles])}>
                    <FormattedMessage
                        defaultMessage="Facebook Instant Articles"
                        description="Facebook Instant Articles"
                        values={getFormatValues()}
                    />
                </li>
                <li className={classNames([styles.service, styles.archives])}>
                    <FormattedMessage
                        defaultMessage=".zip"
                        description=".zip archive"
                        values={getFormatValues()}
                    />
                </li>
            </ul>
        </div>
    </div>
);

Publications.propTypes = propTypes;
Publications.defaultProps = defaultProps;

export default Publications;
